function toLocalIsoDate(value) {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDefaultDateRange() {
  const now = new Date();
  const dateTo = toLocalIsoDate(now);
  const dateFrom = new Date(
    now.getFullYear() - 1,
    now.getMonth(),
    now.getDate()
  );

  return { dateFrom: toLocalIsoDate(dateFrom), dateTo, preset: "1Y" };
}

export function getDateRangeFromPreset(preset) {
  const now = new Date();
  const today = toLocalIsoDate(now);
  let from = null;

  if (preset === "1M") {
    from = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
  } else if (preset === "3M") {
    from = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
  } else if (preset === "6M") {
    from = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
  } else if (preset === "1Y") {
    from = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
  }

  return {
    dateFrom: from ? toLocalIsoDate(from) : null,
    dateTo: from ? today : null,
  };
}

export function sortRows(rows, sortKey, sortDirection) {
  const result = [...rows];
  result.sort((a, b) => {
    let left = a?.[sortKey] ?? "";
    let right = b?.[sortKey] ?? "";

    if (typeof left === "string") {
      return left.localeCompare(right) * sortDirection;
    }

    return (left - right) * sortDirection;
  });

  return result;
}

export function getPaginationRange(currentPage, totalPages) {
  if (totalPages <= 3) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 2) {
    return [1, 2, 3, "...", totalPages];
  }

  if (currentPage >= totalPages - 1) {
    return [1, "...", totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
}
